import afterFill from './afterFill.js';
import afterOpenFolder from './afterOpenFolder.js';
import afterScrollFolder from './afterScrollFolder.js';
import afterToggleCheckbox from './afterToggleCheckbox.js';
export default {
    afterOpenFolder,
    afterScrollFolder,
    afterToggleCheckbox,
    afterFill,
};
